export class Duration {
    perfFeature: boolean;
    start: number;

    constructor() {
        // eslint-disable-next-line compat/compat
        this.perfFeature = Boolean(window.performance && typeof window.performance.now === 'function');
        this.start = this.getCurrentTime();
    }

    getCurrentTime() {
        return this.perfFeature
            // eslint-disable-next-line compat/compat
            ? performance.now()
            : Date.now();
    }

    elapsedMillis() {
        return this.getCurrentTime() - this.start;
    }
}
